"use client";
import React, { useEffect, useState } from "react";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import SDialogHeader from "@/app/_components/SDialogHeader/SDialogHeader";
import ComBG from "@/app/_components/ComBG/ComBG";
import RedeemCashOutUI from "@/app/(redeem)/redeemCashOut/RedeemCashOutUI";
import ScrollableContainer from "@/app/_components/ScrollableContainer/ScrollableContainer";

/**
 * 函数组件版 RedeemFailDialog 的 Props
 */
interface RedeemCashOutDialoProps extends SDialogProps {
    /** 额外参数 */
    // 可根据需要添加其他 Props，例如：errorMessage
}

/**
 * 函数组件版 RedeemFailDialog
 */
export const RedeemCashOutDialogFC: React.FC<RedeemCashOutDialoProps> = (props) => {
    const { fcKey, onClose } = props;
    const { closeDialog } = useDialogMethods(fcKey);
    // ========== 模拟生命周期（类似 class 的 initData / onInit / onEnter） ==========
    // 用一个内部 state 控制对话框是否还可见
    const [isOpen, setIsOpen] = useState(true);
    useEffect(() => {
        return () => {
        };
    }, [props]);

    // ========== 按钮点击逻辑 ==========
    const onClickBack = () => {
        closeDialog();
        onClose?.();
    };

    // ========== 渲染 UI ==========
    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Full"
            onClose={onClose}
        >
            <ComBG>
                <SDialogHeader
                    title="Redeem Cash Out"
                    onClickBack={onClickBack}
                />
                <ScrollableContainer>
                    {/*<div className={"header_panel"}></div>*/}
                    <RedeemCashOutUI/>
                </ScrollableContainer>
            </ComBG>
        </SDialogFC>
    );
};
